import SongContent from "../types/song-type";
import api from "./auth-interceptor";

class CaptchaService {
  getCaptchas(language: string) {
    return api.get<SongContent[]>(`songs/?language=${language}`);
  }

  getAllSongs(){
    return api.get<SongContent[]>(`songs/`)
  }

  createCaptcha(songContent: SongContent) {
    return api.post(`songs/`, songContent);
  }

  deleteSong(songId: string) {
    return api.delete<SongContent[]>(`songs/${songId}`);
  }
}

const captchaService = new CaptchaService();
export default captchaService;
